import { render, staticRenderFns } from "./SecurityNotification.vue?vue&type=template&id=1f85d1f8&scoped=true&"
import script from "./SecurityNotification.vue.js?vue&type=script&lang=js&"
export * from "./SecurityNotification.vue.js?vue&type=script&lang=js&"
import style0 from "./SecurityNotification.vue?vue&type=style&index=0&id=1f85d1f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85d1f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
